import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ExclamationIcon } from 'components/elements/Icons';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function PasswordResetLinkExpired() {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  return (
    <>
      <div className={classes.correctEmailText}>
        <Typography className={classes.caption} variant="h6" component="h6">
          {t('the_link_you_followed_has_expired')}
        </Typography>
      </div>
      <ExclamationIcon classes={classes.exclamationIcon} />
    </>
  );
}

export default PasswordResetLinkExpired;
